'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

var _companyList = require('./company-list.html');

var _companyList2 = _interopRequireDefault(_companyList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _companyList2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    query: '<',
    companies: '<',
    userLockoutChanged: '&',
    queryChanged: '&',
    searchTextChanged: '&',
    complianceChanged: '&'
  },
  controller: function () {
    function CompanyListComponent(EventEmitter) {
      'ngInject';

      var _this = this;

      _classCallCheck(this, CompanyListComponent);

      Object.assign(this, { EventEmitter: EventEmitter });

      this.onPaginationChanged = function (page, take) {
        _this.onQueryChange(_extends({}, _this.query, {
          page: page,
          take: take
        }));
      };

      this.onOrderChanged = function (order) {
        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
        var orderBy = order.replace('-', '');

        _this.onQueryChange(_extends({}, _this.query, {
          direction: direction,
          orderBy: orderBy
        }));
      };
    }

    _createClass(CompanyListComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.limitOptions = (0, _query.getLimitOptions)();
      }
    }, {
      key: 'onQueryChange',
      value: function onQueryChange(query) {
        this.queryChanged(this.EventEmitter({
          query: query
        }));
      }
    }, {
      key: 'onSearchTextChanged',
      value: function onSearchTextChanged(searchText) {
        this.searchTextChanged(this.EventEmitter({
          searchText: searchText
        }));
      }
    }, {
      key: 'onComplianceChanged',
      value: function onComplianceChanged(company) {
        this.complianceChanged(this.EventEmitter({
          company: company
        }));
      }
    }]);

    return CompanyListComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/companies/company-list/company-list.component.js